import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/label/close.png'


const _withScopeId = n => (_pushScopeId("data-v-54de091b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom df vertical active-label" }
const _hoisted_2 = ["onClick", "onMouseenter"]
const _hoisted_3 = {
  key: 0,
  class: "cancel"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "cancel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routeArr, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item df vertical df-center text-style",
        key: index,
        onClick: ($event: any) => (_ctx.toRedirect(item)),
        onMouseenter: ($event: any) => (_ctx.showClose = index),
        onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showClose = false)),
        style: _normalizeStyle([item.name.length > 4 ? 'width: 160px' : ''])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["active-label-text one-row", [item.active ? 'active' : '']])
        }, _toDisplayString(item.name), 3),
        (item.active && item.name !== '首页')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.showClose === index)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_0,
                    alt: "",
                    onClick: _withModifiers(($event: any) => (_ctx.deleteItem(index)), ["stop"])
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]))
          : (item.name !== '首页')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : _createCommentVNode("", true)
      ], 44, _hoisted_2))
    }), 128))
  ]))
}